import { FormInstance } from 'antd';
import { AxiosError } from 'axios';
import { accountApiService } from 'service/api/accountApiService';
import { accountStore } from 'store/accountStore';
import { AccountInterface } from 'type/accountType';

interface ProfileServiceType {
  fetchProfile: (form: FormInstance) => Promise<AccountInterface>;
  updateProfile: (profile: AccountInterface) => Promise<void>;
  updatePassword: (form: FormInstance, oldPassword: string, newPassword: string) => Promise<void>;
}

export const ProfileService: ProfileServiceType = {
  fetchProfile: async (form: FormInstance): Promise<AccountInterface> => {
    const myProfile = await accountStore.fetchAccount();
    form.setFieldsValue(myProfile);
    return myProfile;
  },
  updateProfile: async (profile: AccountInterface): Promise<void> => {
    await accountApiService.updateProfile(profile);
  },
  updatePassword: async (
    form: FormInstance,
    oldPassword: string,
    newPassword: string
  ): Promise<void> => {
    try {
      await accountApiService.updatePassword(oldPassword, newPassword);
    } catch (error) {
      if (error instanceof AxiosError && error.response?.status === 400) {
        const errorData = error.response.data;

        // 각 필드별로 에러 상태를 직접 설정
        if (errorData.old_password) {
          form.setFields([
            {
              name: 'old_password',
              errors: errorData.old_password,
            },
          ]);
        }
        if (errorData.new_password) {
          form.setFields([
            {
              name: 'new_password',
              errors: errorData.new_password,
            },
          ]);
        }
      }
    }
  },
};
